/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Unsubscribe_Invalid_TitleInputs */

const en_newsletter_unsubscribe_invalid_title = /** @type {(inputs: Newsletter_Unsubscribe_Invalid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link doesn't work`)
};

/**
* | output |
* | --- |
* | "This link doesn't work" |
*
* @param {Newsletter_Unsubscribe_Invalid_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_unsubscribe_invalid_title = /** @type {((inputs?: Newsletter_Unsubscribe_Invalid_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Unsubscribe_Invalid_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_unsubscribe_invalid_title(inputs)
});